import EditEpaper from './EditEpaper'

export default EditEpaper
